
<filtered-list-controls [list]="assetList"></filtered-list-controls>
<filtered-list-filters [list]="assetList"></filtered-list-filters>
<table class="table table-sm table-responsive">
  <thead>
    <tr class="table-header-with-controls">
      <th class="device">Device</th>
      <th class="serial-number">Serial Number</th>
      <th class="building-floor">Building/Floor</th>
      <th class="map-id">Map ID</th>
      <th class="device-key">Device Key</th>
      <th class="bulk-order">Bulk Order</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="!assetList.hasFilteredItems">
      <td colspan="6">
        <p class="text-center empty-table-message" *ngIf="!ready">There are no devices to display.</p>
        <p class="text-center empty-table-message" *ngIf="ready">All devices and accessories have device keys.  Change your search, or uncheck "Only show assets that need a device key" to see or change them.</p>
      </td>
    </tr>
    <ng-container *ngFor="let asset of assetList.filtered">
      <tr>
        <td class="device">{{ asset.productNumber }} ({{ asset.productDescription }})</td>
        <td class="serial-number">{{ asset.serialNumber }}</td>
        <td class="building-floor">{{ asset.building }}</td>
        <td class="map-id">{{ asset.floorMapId }}</td>
        <td class="device-key"><span class="device-key" *ngIf="asset.deviceKey">{{ asset.deviceKey }}</span><span class="device-key-no-change" *ngIf="!asset.deviceKey &amp;&amp; asset.isUpdate">(no change)</span><span class="device-key-empty" *ngIf="!asset.deviceKey &amp;&amp; !asset.isUpdate">(empty)</span> <span class="device-key-change-link pl-2"><a href="javascript:void(0);" (click)="changeDeviceKey(asset)"><span class="icon oi oi-pencil"></span></a></span>
        </td>
        <td class="bulk-order" *ngIf="asset.bulkOrderAvailable">{{ asset.orderNumber }} <span class="bulk-order-change-link pl-2"><a href="javascript:void(0);" (click)="changeBulkOrder(asset)"><span class="icon oi oi-pencil"></span></a></span>
        </td>
        <td class="bulk-order" *ngIf="!asset.bulkOrderAvailable"></td>
      </tr>
      <tr class="no-top-border no-top-padding" *ngFor="let accessory of asset.accessories; let isFirst = first">
        <td class="device">[Accessory] {{ accessory.productNumber }} ({{ accessory.productDescription }})</td>
        <td class="serial-number"></td>
        <td class="building-floor">
          <ng-template [ngIf]="isFirst">{{ asset.floor }}</ng-template>
        </td>
        <td class="map-id"></td>
        <td class="device-key"><span class="device-key" *ngIf="accessory.deviceKey &amp;&amp; !accessory.bundled">{{ accessory.deviceKey }}</span><span class="device-key-empty" *ngIf="!accessory.deviceKey &amp;&amp; !accessory.bundled &amp;&amp; (asset.deviceKey || !asset.isUpdate)">(empty)</span><span class="device-key-bundled" *ngIf="accessory.bundled">(bundled)</span><span class="device-key-no-change" *ngIf="!asset.deviceKey &amp;&amp; asset.isUpdate">(no change)</span> <span class="device-key-change-link pl-2" [hidden]="accessory.bundled"><a href="javascript:void(0);" (click)="changeDeviceKey(accessory)"><span class="icon oi oi-pencil"></span></a></span>
        </td>
        <td class="bulk-order" *ngIf="accessory.deviceKey &amp;&amp; accessory.bulkOrderAvailable"></td>
        <td class="bulk-order" *ngIf="!accessory.deviceKey || !accessory.bulkOrderAvailable"></td>
      </tr>
      <tr class="no-top-border no-top-padding" *ngIf="!asset.accessories?.length">
        <td class="device"></td>
        <td class="serial-number"></td>
        <td class="building-floor">{{ asset.floor }}</td>
        <td class="map-id"></td>
        <td class="device-key"></td>
        <td class="bulk-order"></td>
      </tr>
    </ng-container>
  </tbody>
</table>